import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { VipLevelSettings } from 'src/app/shared/models/constants/vip-level-settings';
import { Fields } from 'src/app/utils/fields';

@Injectable({ providedIn: 'root' })
/**
 * Service for create a Vip Settings forms.
 */
export class VipFormBuilderService {
  /**
   * Main method to create a forms
   * @param {VipLevelSettings[]} vipLevels
   * @param {Fields[]} vipFields
   * @return {FormGroup}
   */
  createVipForm(vipLevels: VipLevelSettings[], vipFields: Fields[]): FormGroup {
    const formGroupList: { [key: string]: FormGroup } = {};

    vipLevels.forEach((vip) => {
      formGroupList[vip.id] = this.createFormGroup(vip, vipFields);
    });

    return new FormGroup(formGroupList);
  }

  /**
   * Create a form group
   * @param {VipLevelSettings} vip
   * @param {Fields[]} vipFields
   * @return {FormGroup}
   */
  createFormGroup(vip: VipLevelSettings, vipFields: Fields[]): FormGroup {
    const fieldControls = new Map<string, FormControl>();

    vipFields.forEach((field) => {
      fieldControls.set(field, this.createFieldControl(field, vip));
    });

    return new FormGroup(Object.fromEntries(fieldControls));
  }

  /**
   * Create a FormControl for a specific field.
   * @param {Fields} field
   * @param {any} vip
   * @return {FormControl}
   */
  private createFieldControl(field: Fields, vip: any): FormControl {
    switch (field) {
      case Fields.LABEL:
        return new FormControl(vip.label);

      case Fields.BUSINESS_LEVEL_ID:
        return new FormControl();

      case Fields.NAME:
        return new FormControl('', [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(255),
          Validators.pattern(/^[^"'\\><=+@`{&}]*$/),
        ]);

      case Fields.LEVEL_POINTS:
        return new FormControl(null, [
          Validators.required,
          Validators.min(0),
          Validators.max(99999),
          Validators.pattern(/^-?\d\d*$/),
        ]);

      case Fields.DISCOUNT:
        return new FormControl(null, [
          Validators.required,
          Validators.max(100),
          Validators.min(1),
          Validators.pattern(/^-?\d\d*$/),
        ]);

      default:
        return new FormControl();
    }
  }
}
